var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnDestroy, AfterViewInit, ElementRef } from '@angular/core';
import { DraftService } from './../resultboard/draft/draft.service';
import { MainService } from 'src/app/_services/main.service';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router, NavigationStart, NavigationEnd } from '@angular/router';
import { environment } from './../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ResultboardService } from 'src/app/resultboard/resultboard.service';
import { Playerinfobox2Component } from 'src/app/playerinfobox2/playerinfobox2.component';
import { MatSnackBar } from '@angular/material';
import html2canvas from './../../../node_modules/html2canvas/dist/html2canvas.min.js';
import { ConfirmboxComponent } from 'src/app/confirmbox/confirmbox.component';
var Draft2Component = /** @class */ (function () {
    function Draft2Component(snackBar, store, dialog, router, _draftService, _resultboardService, _mainService, route) {
        var _this = this;
        this.snackBar = snackBar;
        this.store = store;
        this.dialog = dialog;
        this.router = router;
        this._draftService = _draftService;
        this._resultboardService = _resultboardService;
        this._mainService = _mainService;
        this.route = route;
        this.hoverStyle = {
            top: '0px',
            left: '0px',
            display: 'none',
            width: '0px'
        };
        this.queueOptions = {
            handle: '.dragIcon',
            onUpdate: function (event) {
            },
            onEnd: function (event) {
                if (event['oldIndex'] != event['newIndex']) {
                    _this.queueDrop(event['oldIndex'], event['newIndex']);
                }
            }
        };
        this.hoverRoster = null;
        this.hoverRosterPopup = null;
        this.user = null;
        this.isMobile = false;
        this.positionColors = {};
        this.isActiveDraft = false;
        this.currentView = 'slider';
        this.isAutoPick = false;
        this.FakeisAutoPick = false;
        this.browsername = '';
        this.isMac = false;
        this.scrollUpdating = false;
        this.clearKeys = false;
        this.showModal = false;
        this.tableSort = 'order';
        this.tableSortOrder = -1;
        this.showResetIcon = false;
        this.tableNumRows = 6;
        this.tableHeaderHeight = 72;
        this.tableCHeight = this.tableHeaderHeight + (this.tableNumRows * 38) + "px";
        this.showRankings = false;
        this.showLoading = true;
        this.showRoster = {};
        this.showRosterNew = {};
        this.infoTab = null;
        this.scoringTab = null;
        this.showRosterOwner = {};
        this.pickOrder = [];
        this.roster_removed = [];
        this.rankingSets = [];
        this.teams = ['ALL'];
        this.teamFilter = null;
        this.searchTimer = null;
        this.prizesExpand = false;
        this.isMessage = 'open';
        this.league_id = 0;
        this.common_rank_id = 0;
        this.ping_time = 0;
        this.delta = 0;
        this.unreadMessages = 0; // used for chat badge
        this.league_picks = 0; // total picks in the league, calculated
        this.league_rounds = 0; // total rounds of picks, calculated
        this.sliderScroll = 0;
        this.rosterTabIndex = 0;
        this.pScroll = 0;
        this.qScroll = 0;
        this.scrollBarHeight = 0;
        this.currentPick = 1;
        this.timeleft = 0; // pick time remaining in seconds
        this.timeleftTimer = null;
        this.pickInfoBox = null;
        this.readyBox = null;
        this.league = null;
        this.filterStyles = null;
        this.search = '';
        this.players = [];
        this.tablePlayers = [];
        this.slider = [];
        this.queue = [];
        this.queuePlayers = [];
        this.selectedFilters = [];
        this.topIndex = 0;
        this.draftData = null;
        this.sliderState = 'close';
        this.playerSelecting = false;
        this.selectedTab = 0; // used for mat-tab index
        this.filledPosition = {
            'background-color': '#EEE',
            'color': '#000',
            'border': '1px solid transparent'
        };
        // header links
        this.leagueURL = '';
        this.myTeamURL = '';
        this.matchupURL = '';
        this.playersURL = '';
        this.draftURL = '';
        this.settingsURL = '';
        this.siteURL = "" + environment.SITE_URL;
        this.lobbyURL = environment.SITE_URL + "/drafts/lobby";
        this.bucketURL = environment.assetURL + "/assets/default/images/";
        this.playerURL = environment.assetURL + "/assets/uploads/players/";
        // debug
        this.startTime = 0;
        this.endTime = 0;
        this.darkMode = false;
        this.darkMode_ext = '';
        this.showCamIcon = true;
        this.showCanvas = false;
        this.showLoadingBorder = false;
        this.disableDraft = false;
        this.s3url = this.bucketURL + 'logo.png';
        this.imageData = {};
        this.logoUrl = 'assets/default/images/logo-red.png';
        this.allImgsArray = [];
        this.getRosterData = {};
        this.orderKeys = function (a, b) {
            if (_this.league != null && a.value[0].order_id != null)
                return a.value[0].order_id > b.value[0].order_id ? 1 : -1; /**Sort by DB order id */
            else if (_this.league != null && _this.league.game_id == 1)
                return b.value[0].p_pos > a.value[0].p_pos ? 1 : -1;
            else
                return a.value[0].p_pos > b.value[0].p_pos ? 1 : -1;
        };
        this.scrollBarHeight = this.getScrollbarWidth();
        this.store.select('authData').subscribe(function (state) {
            if (state[0]) {
                _this.user = state[0];
                // start data flow
                if (_this.league_id != 0) {
                    _this.setupSockets();
                    _this.getDraftData();
                }
            }
        });
        this.s_navigation = router.events.subscribe(function (event) {
            if (event instanceof NavigationEnd) {
                _this.showLoading = true;
            }
            if (event instanceof NavigationStart) {
                _this.unsubSockets();
                _this.showLoading = true;
            }
        });
        if (navigator.appVersion.indexOf("Mac") != -1)
            this.isMac = true;
        if (navigator.userAgent.match(/AppleWebKit/) && !navigator.userAgent.match(/Chrome/)) {
            this.browsername = 'safaribrowser';
        }
        this.route.params.subscribe(function (params) {
            _this.unsubSockets();
            _this.hoverStyle = {
                top: '0px',
                left: '0px',
                display: 'none',
                width: '0px'
            };
            _this.hoverRoster = null;
            // this.isMessage = 'close';
            _this.sliderState = 'close';
            _this.infoTab = null;
            _this.scoringTab = null;
            _this.showLoading = true;
            _this.players = [];
            _this.tablePlayers = [];
            _this.prizesExpand = false;
            _this.scrollUpdating = false;
            _this.tableCHeight = _this.tableHeaderHeight + (_this.tableNumRows * 38) + "px";
            _this.slider = [];
            _this.teams = ['ALL'];
            _this.rankingSets = [];
            _this.queue = [];
            _this.pickOrder = [];
            _this.roster_removed = [];
            _this.queuePlayers = [];
            _this.league_id = params['league_id'];
            _this.league = null;
            _this.searchTimer = null;
            _this.isAutoPick = false;
            _this.clearKeys = false;
            _this.showModal = false;
            _this.showRankings = false;
            _this.showRoster = {};
            _this.showRosterOwner = {};
            _this.selectedFilters = [];
            _this.filterStyles = null;
            _this.unreadMessages = 0;
            _this.selectedTab = 0;
            _this.sliderScroll = 0;
            _this.qScroll = 0;
            _this.pScroll = 0;
            _this.topIndex = 0;
            _this.rosterTabIndex = 0;
            _this.draftData = null;
            _this.search = '';
            _this.pickInfoBox = null;
            _this.disableDraft = false;
            _this.teamFilter = null;
            if (_this.user != null) {
                _this.setupSockets();
                _this.getDraftData();
            }
        });
        this.s_isMobileScreen = this.store.select('isMobileScreen').subscribe(function (state) {
            if (state.length > 0) {
                _this.isMobile = state[0];
                if (_this.isMobile) {
                    _this.isMobile = (window.innerWidth < 1000) ? true : false;
                }
            }
        });
        this.sub_darkMode = this.store.select('DarkModeReducer').subscribe(function (state) {
            if (state.length > 0) {
                _this.darkMode = state[0].isDarkMode;
                _this.darkMode_ext = _this.darkMode ? '-dark' : '';
                _this.logoUrl = _this.darkMode ? 'assets/default/images/logo.png' : 'assets/default/images/logo-red.png';
                if (_this.darkMode) {
                    _this.filledPosition = {
                        'background-color': 'var(--bkg-color4)',
                        'color': 'var(--text-color4)',
                        'border': '1px solid transparent'
                    };
                }
            }
        });
        var dm = localStorage.getItem('darkMode');
        if (dm == 'true' || dm == null) {
            this.darkMode = false;
            this.toggleDarkTheme();
        }
    }
    Draft2Component.prototype.ngOnInit = function () {
    };
    Draft2Component.prototype.ngOnDestroy = function () {
        this.unsubSockets();
        clearInterval(this.timeleftTimer);
    };
    Draft2Component.prototype.ngAfterViewInit = function () {
        this.showLoading = true;
    };
    Draft2Component.prototype.getDraftData = function () {
        var _this = this;
        if (this.league_id != 0) {
            this.startTime = Date.now();
            this._draftService.getDraftData2(this.league_id, this.user.id).subscribe(function (res) {
                if (res.status != null && res.status == 1) {
                    // console.log(res);
                    _this.league = res.entities.league;
                    _this.common_rank_id = res.entities.league.common_rank_id;
                    _this.isAutoPick = (res.entities.apm > 0) ? true : false;
                    // console.log(this.league);
                    _this.draftData = res.entities;
                    // console.log(this.draftData);
                    if (_this.draftData.lgm.length > 4) {
                        _this.currentView = 'table';
                    }
                    else {
                        _this.currentView = 'slider';
                    }
                    _this.rosterTabIndex = _this.draftData.lgm.reduce(function (acc, lm, index) {
                        if (lm.team_id == _this.draftData.myteam_id)
                            acc = index;
                        return acc;
                    }, 0);
                    _this.pickInfoBox = res.entities.pick_info_box;
                    if (_this.pickInfoBox && _this.pickInfoBox.status == 1) {
                        setTimeout(function () {
                            if (_this.reloadConfirmDialogRef)
                                _this.reloadConfirmDialogRef.close();
                            _this.reloadConfirmDialogRef = _this.dialog.open(ConfirmboxComponent, {
                                width: '500px',
                                data: {
                                    title: "Refresh Page Alert",
                                    body: 'The draft is not full yet. Please check back again when the draft started.',
                                    cancelBtn: false
                                }
                            });
                            _this.reloadConfirmDialogRef.afterClosed().subscribe(function (res) {
                                document.location.href = environment.SITE_URL + "/drafts/lobby";
                            });
                        }, 1000);
                    }
                    if (_this.pickInfoBox.status == 4) {
                        _this.currentView = 'table';
                        _this.tableCHeight = 'none';
                        _this.removeAllPositions();
                    }
                    setTimeout(function () {
                        _this.resetTableRowsView();
                    }, 2000);
                    // console.log(this.pickInfoBox);
                    _this.readyBox = res.entities.ready_box;
                    _this.readyBox.im_ready = false; // update this once we get info from gary
                    _this.currentPick = _this.pickInfoBox.pick_number;
                    if (_this.pickInfoBox.status == 2 || _this.pickInfoBox.status == 4 || _this.pickInfoBox.status == 5 || _this.league.duration_id == 8)
                        _this.isMessage = 'open';
                    _this.timeleft = Math.round(_this.pickInfoBox.timestamp + _this.delta - Date.now() / 1000) - 1;
                    if (_this.pickInfoBox.status == 3 || _this.pickInfoBox.status == 2) {
                        _this.startTimer();
                    }
                    _this.filterStyles = {};
                    _this.draftData.roster_position.forEach(function (rp) {
                        if (rp.pname == 'All') {
                            rp.tpick = (_this.league.duration_id != 8) ? _this.draftData.roster_position.reduce(function (acc, r) { if (r.pname != 'All')
                                acc += r.tpick; return acc; }, 0) : _this.league.total_players;
                            rp.cpick = _this.draftData.roster_position.reduce(function (acc, r) { return acc += r.cpick; }, 0);
                        }
                        _this.filterStyles[rp.pname] = {
                            'color': '#FFF',
                            'background-color': _this.getRGBAColor(rp.color_code),
                            'border': '1px solid ' + _this.getRGBAColor(rp.color_code),
                            'text-shadow': 'none'
                        };
                        var colorcode = _this.getRGBAColor(rp.color_code);
                        _this.filterStyles[rp.pname + '-off'] = {
                            'color': (rp.pname == 'All' || rp.pname == 'Hitters') ? 'var(--text-color)' : colorcode,
                            // 'background-color': 'var(--position-default)',
                            'border': '1px solid ' + _this.getRGBAColor(rp.color_code),
                            'text-shadow': 'none'
                        };
                    });
                    _this.selectedFilters = _this.draftData.roster_position.reduce(function (obj, elm) {
                        obj.push(elm.pname);
                        return obj;
                    }, []);
                    // debug
                    // this.currentPick = 14;
                    // this.timeleft = 35;
                    // this.pickInfoBox.status = 3;
                    // end debug
                    // set league_picks and league_rounds (use league_rounds for mod to reverse order)
                    _this.league_picks = (_this.league.duration_id != 8) ? _this.draftData.roster_position.reduce(function (acc, r) { if (r.pname != 'All')
                        acc += r.tpick; return acc; }, 0) * _this.draftData.lgm.length : _this.league.total_players * _this.draftData.lgm.length;
                    _this.league_rounds = _this.league_picks / _this.draftData.lgm.length;
                    for (var i = 0; i < _this.league_rounds; i++) {
                        for (var j = 0; j < _this.draftData.lgm.length; j++) {
                            if (j == 0 && i > 0)
                                _this.draftData.lgm.reverse();
                            // set up this.slider
                            _this.slider.push({
                                round: i + 1,
                                pick: j + 1,
                                total_pick: i * _this.draftData.lgm.length + (j + 1),
                                team_name: _this.draftData.lgm[j].drafters_id,
                                team_picture: _this.draftData.lgm[j].imageUrl,
                                image: _this.draftData.lgm[j].imageUrl,
                                lgm_id: _this.draftData.lgm[j].team_id,
                                bgColor: 'rgb(80, 219, 13)',
                                user_id: _this.draftData.lgm[j].user_id
                            });
                            if (j == _this.draftData.lgm.length - 1 && i == _this.league_rounds - 1 && i % 2) {
                                // last iteration complete, odd final index, swap back to restore order
                                _this.draftData.lgm.reverse();
                            }
                        }
                    }
                    _this.setRosterRemoved();
                    // console.log('end getDraftData');
                    // console.log('call setHeaderLinks');
                    _this.setHeaderLinks(_this.draftData);
                    // console.log('call getPlayerPool');
                    _this.getPlayerPool();
                    if (_this.league.duration_id == 10) {
                        _this.tableHeaderHeight = 131.5;
                        _this.tableCHeight = _this.tableHeaderHeight + (_this.tableNumRows * 38) + "px";
                    }
                }
            });
        }
    };
    Draft2Component.prototype.setupSockets = function () {
        var _this = this;
        if (this.s_disconnect)
            this.s_disconnect.unsubscribe();
        this.s_disconnect = this._resultboardService.disconnectEvent().subscribe(function (r) {
            _this.openSnackBar('Connection Lost, Refreshing...', 'OK');
            setTimeout(function () {
                if (_this.reloadConfirmDialogRef)
                    _this.reloadConfirmDialogRef.close();
                _this.reloadConfirmDialogRef = _this.dialog.open(ConfirmboxComponent, {
                    width: '500px',
                    data: { 'title': "Refresh Page Alert", 'body': 'Draft has disconnected... please refresh the page.' }
                });
                _this.reloadConfirmDialogRef.afterClosed().subscribe(function (res) {
                    document.location.reload();
                });
            }, 2000);
        });
        if (this.s_pong)
            this.s_pong.unsubscribe();
        this.s_pong = this._resultboardService.pong().subscribe(function (r) {
            var ts = Date.now();
            var server_time = r.t;
            var transit = (ts - _this.ping_time) / 2;
            _this.delta = ts - (server_time + transit);
            _this.delta /= 1000; // in seconds, not milliseconds
            // console.log('delta', this.delta);
        });
        if (this.s_refreshPage)
            this.s_refreshPage.unsubscribe();
        this.s_refreshPage = this._resultboardService.refreshPage().subscribe(function (r) {
            if (r.status == 1) {
                if (_this.reloadConfirmDialogRef)
                    _this.reloadConfirmDialogRef.close();
                _this.reloadConfirmDialogRef = _this.dialog.open(ConfirmboxComponent, {
                    width: '500px',
                    data: { 'title': "Refresh Page Alert", 'body': 'Draft has disconnected... please refresh the page.' }
                });
                _this.reloadConfirmDialogRef.afterClosed().subscribe(function (res) {
                    document.location.reload();
                });
            }
        });
        if (this.s_initListener)
            this.s_initListener.unsubscribe();
        this.s_initListener = this._resultboardService.draftAppListener().subscribe(function (r) {
            _this.draftData.position_removed = r.entities.position_removed;
            _this.setRosterRemoved();
            _this.pickInfoBox = r.entities.pick_info_box;
            if (_this.pickInfoBox.status == 4) {
                _this.currentView = 'table';
                _this.tableCHeight = 'none';
                _this.removeAllPositions();
            }
            _this.timeleft = Math.round(_this.pickInfoBox.timestamp + _this.delta - Date.now() / 1000) - 1; // seconds remaining
            _this.startTimer();
            r.entities.pick_order.forEach(function (p) {
                var index = p.pnum - 1;
                if (_this.slider[index].player == null) {
                    var myPosition = _this.draftData.roster_position.filter(function (rp) { return rp.pname == p.ppos; });
                    var myTeamData = _this.draftData.lgm.filter(function (lm) { return lm.team_id == p.id; });
                    _this.slider[index].player_id = p.player_id;
                    _this.slider[index].p_pos = (myPosition.length > 0) ? myPosition[0].id : '';
                    _this.slider[index].owner = (myTeamData.length > 0) ? myTeamData[0].team_name : '';
                    _this.slider[index].player_picture = p.imageUrl;
                    var color = p.color_code;
                    var rgbaColor = _this.getRGBAColor(color);
                    _this.slider[index].bgColor = rgbaColor;
                    _this.slider[index].bye_week = (_this.league.duration_id == 8) ? " (" + _this.players[_this.slider[index].player_id].bye + ")" : "";
                    _this.slider[index].team = _this.players[_this.slider[index].player_id].tn.toUpperCase();
                    _this.slider[index].player = (_this.slider[index].p_pos != 16) ? _this.players[_this.slider[index].player_id].fn.substr(0, 1) + '. ' + _this.players[_this.slider[index].player_id].ln : _this.players[_this.slider[index].player_id].fn + ' ' + _this.players[_this.slider[index].player_id].ln;
                    _this.slider[index].player_name_full = _this.players[_this.slider[index].player_id].fn + ' ' + _this.players[_this.slider[index].player_id].ln;
                    _this.players[p.player_id]['own'] = 'yes';
                    if (parseInt(p.user_id) == _this.user.id) {
                        _this.updateCPick();
                        _this.setRosterRemoved();
                    }
                    _this.currentPick = p.pnum + 1;
                    if (_this.pickInfoBox.status == 3 || _this.pickInfoBox.status == 5) {
                        // slide to current pick far right, or just 0
                        if (_this.currentView == 'slider') {
                            var sliderRef = _this.sliderContainer.nativeElement;
                            sliderRef.scrollLeft = ((_this.currentPick - Math.floor(sliderRef.clientWidth / 95) > 0) ? (_this.currentPick - Math.floor(sliderRef.clientWidth / 95)) * 95 - 1 : 0);
                        }
                        else {
                            var tRef = _this.tContainer.nativeElement;
                            if (!_this.showResetIcon) {
                                tRef.scrollTop = ((Math.floor((_this.currentPick - 1) / _this.draftData.lgm.length) - 5) * 40);
                                setTimeout(function () {
                                    _this.showResetIcon = false;
                                }, 800);
                            }
                            if (tRef.scrollWidth > tRef.clientWidth) {
                                tRef.scrollLeft = (Math.floor((_this.currentPick - 1) / _this.draftData.lgm.length) % 2) ? 30 + ((_this.draftData.lgm.length - ((_this.currentPick - 1) % _this.draftData.lgm.length)) - 3) * 95 : 30 + ((((_this.currentPick - 1) % _this.draftData.lgm.length) - 2) * 95);
                            }
                        }
                    }
                }
                if (_this.slider != null && _this.slider[_this.currentPick - 1] != null && _this.slider[_this.currentPick - 1].lgm_id == _this.draftData.myteam_id && _this.user.pick_sound)
                    _this._resultboardService.playSound();
            });
            _this.getPickOrder();
        });
        if (this.s_pickChanges)
            this.s_pickChanges.unsubscribe();
        this.s_pickChanges = this._resultboardService.pickChanges().subscribe(function (r) {
            // console.log('s_pickChanges', r);
            if (r.entities != null && _this.league != null && parseInt(r.entities.league.id) == _this.league.id) {
                _this.pickInfoBox = r.entities.pick_info_box;
                if (_this.pickInfoBox.is_active == 1) {
                    _this.disableDraft = false;
                }
                if (_this.pickInfoBox.status == 3) {
                    if (_this.pickInfoBox.is_active == 1) {
                        window.document.title = 'Your Pick!';
                        _this.resetTableRowsView();
                    }
                    else if (_this.pickInfoBox.message != null) {
                        window.document.title = _this.pickInfoBox.message.replace("turn until your pick", "away");
                    }
                }
                else {
                    window.document.title = 'Drafters';
                }
                _this.currentPick = _this.pickInfoBox.pick_number;
                _this.readyBox.message = r.entities.pick_info_box.message;
                // this.checkMissedPicks();
                if (_this.pickInfoBox.status == 4) {
                    _this.currentView = 'table';
                    _this.tableCHeight = 'none';
                    _this.removeAllPositions();
                    _this.isMessage = 'open';
                    _this.isAutoPick = false;
                    _this.getTablePlayers();
                    _this.getQueuePlayers();
                    setTimeout(function () { return (_this.getShowRoster(_this.draftData.myteam_id, false, false)); }, 2000);
                }
                else {
                    _this.getShowRoster(_this.current_lgm_id ? _this.current_lgm_id : _this.draftData.lgm[_this.rosterTabIndex].team_id, true);
                }
                _this.timeleft = Math.round(_this.pickInfoBox.timestamp + _this.delta - Date.now() / 1000) - 1; // seconds remaining
                if (_this.pickInfoBox.status != 5) {
                    _this.startTimer();
                }
                else {
                    clearInterval(_this.timeleftTimer);
                }
                // if (this.pickInfoBox.status == 3 && this.league.duration_id != 8 && !this.isAutoPick) this.isMessage = 'close';
            }
        });
        if (this.s_listActiveDraft)
            this.s_listActiveDraft.unsubscribe();
        this.s_listActiveDraft = this._resultboardService.listActiveDraft().subscribe(function (r) {
            // console.log('s_listActiveDraft',r);
            // remove old players keys by name if they're not in r.entities
            if (!_this.clearKeys) {
                var existingDrafts_1 = r.entities.reduce(function (acc, obj) {
                    acc.push(obj.league_id);
                    return acc;
                }, []);
                var existingKeys_1 = localStorage.getItem('draft_keys');
                var roster_mt_1 = JSON.parse(localStorage.getItem('roster_mt'));
                var updated_roster_mt_1 = {};
                existingKeys_1 = JSON.parse(existingKeys_1);
                var existingKeysUnchanged_1 = (existingKeys_1 != null) ? existingKeys_1.slice() : null; //create clone with own property
                if (existingKeysUnchanged_1 != null) {
                    existingKeysUnchanged_1.forEach(function (k, i) {
                        if (existingDrafts_1.indexOf(parseInt(k)) == -1 || (existingKeysUnchanged_1.length > 5 && i < existingKeysUnchanged_1.length - 5)) {
                            // delete players key here
                            existingKeys_1.splice(i, 1);
                            localStorage.removeItem('players_' + k);
                        }
                        else if (roster_mt_1 != null && roster_mt_1[k] != null) {
                            updated_roster_mt_1[k] = roster_mt_1[k]; /**Refector the updated time */
                        }
                    });
                    try {
                        localStorage.setItem('draft_keys', JSON.stringify(existingKeys_1));
                        localStorage.setItem('roster_mt', JSON.stringify(updated_roster_mt_1));
                    }
                    catch (e) {
                        // quota
                    }
                }
                _this.clearKeys = true;
            }
        });
        if (this.s_pickedPlayer)
            this.s_pickedPlayer.unsubscribe();
        this.s_pickedPlayer = this._resultboardService.pickedPlayer().subscribe(function (r) {
            if (r.entities != null && _this.league != null && parseInt(r.entities.league_id) == _this.league.id) {
                if (parseInt(r.entities.picked_player.user_id) == _this.user.id) {
                    _this.isAutoPick = (r.entities.autopickmode == 0) ? false : true;
                    if (_this.isAutoPick)
                        _this.isMessage = 'open';
                }
                var index = r.entities.picked_player.pnum - 1;
                var myTeamData = _this.draftData.lgm.filter(function (lm) { return lm.team_id == r.entities.picked_player.id; });
                _this.slider[index].player_id = r.entities.picked_player.player_id;
                _this.slider[index].p_pos = r.entities.gp_id;
                _this.slider[index].owner = (myTeamData.length > 0) ? myTeamData[0].team_name : '';
                _this.slider[index].player_picture = r.entities.picked_player.imageUrl;
                var color = r.entities.picked_player.color_code;
                var rgbaColor = _this.getRGBAColor(color);
                _this.slider[index].bgColor = rgbaColor;
                _this.slider[index].player = (r.entities.gp_id != 16) ? _this.players[_this.slider[index].player_id].fn.substr(0, 1) + '. ' + _this.players[_this.slider[index].player_id].ln : _this.players[_this.slider[index].player_id].fn + ' ' + _this.players[_this.slider[index].player_id].ln;
                _this.slider[index].player_name_full = _this.players[_this.slider[index].player_id].fn + ' ' + _this.players[_this.slider[index].player_id].ln;
                _this.slider[index].bye_week = (_this.league.duration_id == 8) ? " (" + _this.players[_this.slider[index].player_id].bye + ")" : "";
                _this.slider[index].team = (_this.players[_this.slider[index].player_id].tn != null) ? _this.players[_this.slider[index].player_id].tn.toUpperCase() : "";
                _this.players[r.entities.picked_player.player_id]['own'] = 'yes';
                if (parseInt(r.entities.picked_player.user_id) == _this.user.id) {
                    _this.draftData.position_removed = r.entities.position_removed;
                    _this.updateCPick();
                    _this.setRosterRemoved();
                    // this.draftData.roster_position.forEach(rp => {
                    //   if (rp.pname == r.entities.picked_player.ppos){
                    //     rp.cpick++;
                    //   }
                    // });
                }
                _this.currentPick = r.entities.picked_player.pnum + 1;
                if (_this.pickInfoBox.status == 3 || _this.pickInfoBox.status == 5) {
                    if (_this.currentView == 'slider') {
                        // slide to current pick far right, or just 0
                        var sliderRef = _this.sliderContainer.nativeElement;
                        sliderRef.scrollLeft = ((_this.currentPick - Math.floor(sliderRef.clientWidth / 95) > 0) ? (_this.currentPick - Math.floor(sliderRef.clientWidth / 95)) * 95 - 1 : 0);
                    }
                    else {
                        var tRef = _this.tContainer.nativeElement;
                        if (!_this.showResetIcon) {
                            tRef.scrollTop = ((Math.floor((_this.currentPick - 1) / _this.draftData.lgm.length) - 5) * 40);
                            setTimeout(function () {
                                _this.showResetIcon = false;
                            }, 800);
                        }
                        // console.log(this.draftData.lgm.length - ((this.currentPick - 1) % this.draftData.lgm.length));
                        if (tRef.scrollWidth > tRef.clientWidth) {
                            tRef.scrollLeft = (Math.floor((_this.currentPick - 1) / _this.draftData.lgm.length) % 2) ? 30 + ((_this.draftData.lgm.length - ((_this.currentPick - 1) % _this.draftData.lgm.length)) - 3) * 95 : 30 + ((((_this.currentPick - 1) % _this.draftData.lgm.length) - 2) * 95);
                        }
                    }
                }
                _this.checkMissedPicks(r.entities.picked_player.pnum + 1);
                if (_this.slider != null && _this.slider[_this.currentPick - 1] != null && _this.slider[_this.currentPick - 1].lgm_id == _this.draftData.myteam_id && _this.user.pick_sound)
                    _this._resultboardService.playSound();
                if (_this.pickInfoBox.status == 4) {
                    _this.currentView = 'table';
                    _this.tableCHeight = 'none';
                    // this.draftCompleted();
                    _this.isMessage = 'open';
                }
                _this.getShowRoster(_this.current_lgm_id ? _this.current_lgm_id : _this.draftData.lgm[_this.rosterTabIndex].team_id, true);
                _this.getTablePlayers();
                _this.getQueuePlayers();
                _this.getPickOrder();
            }
            if (parseInt(r.entities.picked_player.user_id) == _this.user.id) {
                _this.clearSearch();
                _this.clearFilter();
            }
            _this.getHoverRoster(r.entities.picked_player.id);
        });
        // if (this.s_draftCompleted) this.s_draftCompleted.unsubscribe();
        // this.s_draftCompleted = this._resultboardService.draftCompleted().subscribe(r => {
        //   // console.log('s_draftCompleted',r);
        //   this.pickInfoBox = r.pick_info_box;
        //   if (this.pickInfoBox.status == 4) this.removeAllPositions();
        //   this.isMessage = 'open';
        //   this.isAutoPick = false;
        //   this.getTablePlayers();
        //   this.getQueuePlayers();
        //   this.getShowRoster(this.draftData.myteam_id);
        // });
        if (this.s_showDraft)
            this.s_showDraft.unsubscribe();
        this.s_showDraft = this._resultboardService.showDraftStatus().subscribe(function (r) {
            // console.log('s_showDraft', r);
        });
        if (this.s_draftReset)
            this.s_draftReset.unsubscribe();
        this.s_draftReset = this._resultboardService.draftReset().subscribe(function (r) {
            // console.log('s_draftReset',r);
            location.reload(); // refresh if the draft resets
        });
        if (this.s_reversePick)
            this.s_reversePick.unsubscribe();
        this.s_reversePick = this._resultboardService.lastPickReverse().subscribe(function (r) {
            // console.log('s_reversePick',r);
            location.reload(); // refresh if reverse picks
        });
        if (this.s_leaguePost)
            this.s_leaguePost.unsubscribe();
        this.s_leaguePost = this._resultboardService.draftMessage().subscribe(function (r) {
            // console.log('s_leaguePost',r);
            if (r.entities.feed_type == 'league_message' && _this.selectedTab != 2)
                _this.unreadMessages++;
        });
        if (this.s_pausedMessage)
            this.s_pausedMessage.unsubscribe();
        this.s_pausedMessage = this._resultboardService.pausedMessage().subscribe(function (r) {
            // console.log('s_pausedMessage',r);
            if (_this.league != null && _this.league.id != null && r.league_id == _this.league.id) {
                _this.pickInfoBox.status = 5;
                _this.isMessage = 'open';
                clearInterval(_this.timeleftTimer);
            }
        });
        if (this.s_resumeMessage)
            this.s_resumeMessage.unsubscribe();
        this.s_resumeMessage = this._resultboardService.resumeMessage().subscribe(function (r) {
            // console.log('s_resumeMessage',r);
            if (_this.league != null && _this.league.id != null && r.league_id == _this.league.id) {
                _this.pickInfoBox.status = 3;
                // if (this.pickInfoBox.status == 3 && this.league.duration_id != 8 && !this.isAutoPick) this.isMessage = 'close';
                _this.pickInfoBox.timestamp = r.timestamp;
                _this.timeleft = Math.round(_this.pickInfoBox.timestamp + _this.delta - Date.now() / 1000) - 1; // seconds remaining
                _this.startTimer();
            }
        });
        // obsolete
        // if (this.s_predraft) this.s_predraft.unsubscribe();
        // this.s_predraft = this._resultboardService.predraft().subscribe(r => {
        //   // console.log('s_predraft',r);
        //   this.timeleft = r;
        //   this.pickInfoBox.status = 2;
        //   this.startTimer();
        // });
        if (this.s_readybox)
            this.s_readybox.unsubscribe();
        this.s_readybox = this._resultboardService.readybox().subscribe(function (r) {
            // console.log('s_readybox',r);
            if (r.entities.user_id == _this.draftData.myteam_id) {
                _this.readyBox.im_ready = true;
            }
            _this.readyBox.message = r.entities.message;
            _this.getPickOrder();
        });
    };
    Draft2Component.prototype.imReady = function (event) {
        if (event.checked) {
            this._resultboardService.imReady(this.league.id, this.user.id, this.league.entrants);
            this.readyBox.im_ready = true;
        }
    };
    Draft2Component.prototype.leaveRoom = function () {
        if (this.league != null && this.league.id != null)
            this._resultboardService.leaveRoom(this.league.id);
    };
    Draft2Component.prototype.socketConnect = function () {
        var _this = this;
        this._resultboardService.callDraftApp(this.draftData.myteam_id, this.league.id);
        if (this.s_activeDraft)
            this.s_activeDraft.unsubscribe();
        this.s_activeDraft = this._resultboardService.activeDraftEmit({
            user_id: this.user.id,
            is_app: 1,
            is_connect: 1
        }).subscribe(function (res) {
            _this.s_activeDraft.unsubscribe();
        });
        // start delta process
        this.ping_time = Date.now();
        this._resultboardService.ping();
    };
    Draft2Component.prototype.getPlayerPool = function (overwrite) {
        var _this = this;
        if (overwrite === void 0) { overwrite = false; }
        // console.log('getPlayerPool start');
        // check localstorage first, if no key for this league_id+lgm_id combination, hit endpoint
        var localPlayers = localStorage.getItem('players_' + this.league_id);
        var roster_mt = JSON.parse(localStorage.getItem('roster_mt'));
        var cacheExpired = (roster_mt != null && roster_mt[this.league_id] != null && roster_mt[this.league_id] >= this.draftData.last_modify) ? false : true;
        if (localPlayers == null || overwrite || cacheExpired) {
            this._draftService.getPlayerTable(this.league_id, this.league.game_id, this.league.season_id, this.league.event_type_id, this.draftData.myteam_id, 'draft', this.league.egs, this.league.lgs, this.league.duration_id).subscribe(function (data) {
                // console.log('getPlayerTable service');
                _this.players = data.entities.reduce(function (map, obj, index) {
                    map[parseInt(obj.id)] = obj;
                    if (_this.league.simple != null && _this.league.simple == 'Y' && obj.pn.indexOf(',') > -1) {
                        map[parseInt(obj.id)].pn = obj.pn.substr(0, obj.pn.indexOf(','));
                    }
                    map[parseInt(obj.id)].order = index + 1;
                    map[parseInt(obj.id)].id = parseInt(obj.id);
                    if (obj.it == null)
                        map[parseInt(obj.id)].it = '';
                    if (obj.avg == null && obj.fpts != null && obj.gp != null)
                        map[parseInt(obj.id)].avg = (obj.gp > 0) ? obj.fpts / obj.gp : 0;
                    return map;
                }, {});
                // console.log(this.players);
                // store to localStorage if draft isn't done
                try {
                    if (_this.pickInfoBox.status != 4) {
                        // console.log('storing players key localStorage');
                        localStorage.setItem('players_' + _this.league_id, JSON.stringify(_this.players));
                        var existingKeys = JSON.parse(localStorage.getItem('draft_keys'));
                        if (existingKeys != null) {
                            if (existingKeys.indexOf(_this.league_id) == -1) {
                                existingKeys.push(_this.league_id);
                                try {
                                    localStorage.setItem('draft_keys', JSON.stringify(existingKeys));
                                }
                                catch (er) {
                                    // quota
                                }
                            }
                        }
                        else {
                            existingKeys = [_this.league_id];
                            try {
                                localStorage.setItem('draft_keys', JSON.stringify(existingKeys));
                            }
                            catch (er) {
                                // quota error
                            }
                        }
                        /**Roster update time caching */
                        var last_modify = (_this.draftData.last_modify != null) ? _this.draftData.last_modify : '0';
                        if (roster_mt != null) {
                            roster_mt[_this.league_id] = last_modify;
                            try {
                                localStorage.setItem('roster_mt', JSON.stringify(roster_mt));
                            }
                            catch (er) {
                                // quota
                            }
                        }
                        else {
                            var roster_mt_updated = {};
                            roster_mt_updated[_this.league_id] = last_modify;
                            try {
                                localStorage.setItem('roster_mt', JSON.stringify(roster_mt_updated));
                            }
                            catch (er) {
                                //  
                            }
                        }
                    }
                }
                catch (e) {
                    // quota likely exceeded, user will have to fetch players each time
                    // console.log(e);
                }
                // need to get player binary once we switch to new draft players api using redis key
                // if (this.pickInfoBox.status != 4){
                // should do no matter stage of draft, as order is used in infoboxes
                // console.log('call getPlayerBinary');
                // this.getPlayerBinary();
                // } else {
                // console.log('call getSliderData');
                if (!overwrite) {
                    _this.getSliderData();
                }
                else {
                    // need to update player.own values from existing slider data
                    _this.slider.forEach(function (s) {
                        if (s.player_id != null)
                            _this.players[s.player_id]['own'] = 'yes';
                    });
                    _this.getTablePlayers();
                    _this.getQueuePlayers();
                    _this.getPickOrder();
                }
                // }
            });
        }
        else {
            // console.log('players key already exists');
            // use local players
            this.players = JSON.parse(localPlayers);
            // console.log(this.players);
            // check for player order information, getSliderData if available, else getPlayerBinary()
            if (Object.keys(this.players).filter(function (id) { return _this.players[id].order != null; }).length) { // || this.pickInfoBox.status == 4){
                // console.log('order already exists, call getSliderData');
                this.getSliderData();
            }
            else {
                // console.log('order doesn\'t exist, call getPlayerBinary');
                this.getPlayerBinary();
            }
        }
    };
    Draft2Component.prototype.getPlayerBinary = function () {
        var _this = this;
        // call /getPlayers and update order
        // console.log('getPlayerBinary start');
        this._draftService.getPlayerData(this.league_id, this.league.game_id, this.league.season_id, this.league.event_type_id, this.draftData.myteam_id, 'draft', this.league.egs, this.league.lgs, this.league.duration_id, this.pickInfoBox.status).subscribe(function (res) {
            // console.log('getPlayerData service');
            res.arrayBuffer().then(function (buffer) {
                var N = buffer.byteLength / 20; // change this if expanded to queue bitmap
                var order = new Int32Array(buffer, 0, N);
                var col1 = new Float64Array(buffer, N * 4, N);
                var col2 = new Float64Array(buffer, N * 4 + N * 8, N);
                // console.log('getPlayerData N: ' + N);
                order.forEach(function (o, i) {
                    if (_this.players[o] != null) {
                        _this.players[o].order = i;
                        _this.players[o][_this.draftData.col1.col] = col1[i];
                        _this.players[o][_this.draftData.col2.col] = col2[i];
                    }
                });
                // console.log(this.players);
                // save players data with order
                try {
                    if (_this.pickInfoBox.status != 4) {
                        // console.log('store players localStorage key');
                        localStorage.setItem('players_' + _this.league_id, JSON.stringify(_this.players));
                    }
                }
                catch (e) {
                    // quota exceeded
                }
                // console.log('call getSliderData');
                _this.getSliderData();
            });
        });
    };
    Draft2Component.prototype.getSliderData = function () {
        var _this = this;
        Object.keys(this.players).forEach(function (pid) {
            if (!_this.teams.includes(_this.players[pid].tn.toUpperCase()))
                _this.teams.push(_this.players[pid].tn.toUpperCase());
        });
        this.teams.sort();
        // console.log('getSliderData start');
        this._draftService.getSliderData(this.league_id).subscribe(function (res) {
            // console.log('getSliderData service');
            res.arrayBuffer().then(function (buffer) {
                if (buffer.byteLength > 1) {
                    // reconstruct int32array
                    // const intView = new DataView(buffer);
                    var N = buffer.byteLength / 12;
                    var sliderArr = new Int32Array(buffer, 0, N * 3);
                    // console.log('getSliderData N: ' + N);
                    for (var index = 0; index < N; index++) {
                        _this.slider[index].lgm_id = sliderArr[index * 3];
                        _this.slider[index].player_id = sliderArr[index * 3 + 1];
                        _this.slider[index].p_pos = sliderArr[index * 3 + 2];
                    }
                    // console.log(this.slider);
                    // for (let index=0;index<buffer.byteLength/12;index++){
                    //   const player_id = intView.getInt32(index*12 + 4);
                    //   this.slider.push({
                    //     lgm_id: intView.getInt32(index*12),
                    //     player_id,
                    //     p_pos: intView.getInt32(index*12 + 8)
                    //   });
                    //   this.players[player_id].is_picked = 'Y';
                    // }
                    // add in teams data and player data to slider entries here
                    _this.slider.forEach(function (slide, index) {
                        if (_this.players[slide.player_id] != null) {
                            slide.player = (slide.p_pos != 16) ? _this.players[slide.player_id].fn.substr(0, 1) + '. ' + _this.players[slide.player_id].ln : _this.players[slide.player_id].fn + ' ' + _this.players[slide.player_id].ln;
                            slide.player_name_full = _this.players[slide.player_id].fn + ' ' + _this.players[slide.player_id].ln;
                            slide.bye_week = (_this.league.duration_id == 8) ? " (" + _this.players[slide.player_id].bye + ")" : "";
                            slide.team = _this.players[slide.player_id].tn.toUpperCase();
                            slide.owner = _this.draftData.lgm.filter(function (lm) { return lm.team_id == slide.lgm_id; })[0].team_name;
                            slide.player_picture = _this.playerURL + _this.players[slide.player_id].pp;
                            var color = _this.draftData.roster_position.filter(function (rp) { return rp.id == slide.p_pos; })[0].color_code;
                            var rgbaColor = _this.getRGBAColor(color);
                            slide.bgColor = rgbaColor;
                            _this.players[slide.player_id]['own'] = 'yes';
                        }
                    });
                    // console.log(this.slider);
                }
                // console.log('set currentPick');
                // make sure currentPick value isn't outdated since we called getDraftData
                if (_this.slider.filter(function (s) { return s.player != null; }).length + 1 > _this.currentPick) {
                    _this.currentPick = _this.slider.filter(function (s) { return s.player != null; }).length + 1;
                }
                if (_this.league.duration_id == 10) {
                    _this.draftData.lgm.map(function (teamData) {
                        _this.getHoverRoster(teamData.team_id);
                    });
                }
                // console.log(this.slider);
                _this.endTime = Date.now();
                // console.log("Data ready in " + (this.endTime - this.startTime) / 1000 + "s");
                setTimeout(function () {
                    _this.showLoading = false;
                }, 1000);
                setTimeout(function () {
                    if (_this.pickInfoBox.status == 3 || _this.pickInfoBox.status == 5) {
                        // console.log('slide to current pick');
                        // slide to current pick far right, or just 0
                        if (_this.currentView == 'slider') {
                            var sliderRef = _this.sliderContainer.nativeElement;
                            sliderRef.scrollLeft = ((_this.currentPick - Math.floor(sliderRef.clientWidth / 95) > 0) ? (_this.currentPick - Math.floor(sliderRef.clientWidth / 95)) * 95 - 1 : 0);
                        }
                        else {
                            var tRef = _this.tContainer.nativeElement;
                            if (!_this.showResetIcon) {
                                tRef.scrollTop = ((Math.floor((_this.currentPick - 1) / _this.draftData.lgm.length) - 5) * 40);
                                setTimeout(function () {
                                    _this.showResetIcon = false;
                                }, 800);
                            }
                            if (tRef.scrollWidth > tRef.clientWidth) {
                                tRef.scrollLeft = (Math.floor((_this.currentPick - 1) / _this.draftData.lgm.length) % 2) ? 30 + ((_this.draftData.lgm.length - ((_this.currentPick - 1) % _this.draftData.lgm.length)) - 3) * 95 : 30 + ((((_this.currentPick - 1) % _this.draftData.lgm.length) - 2) * 95);
                            }
                        }
                    }
                }, 500);
                _this.sliderState = 'open';
                // this.getTablePlayers();
                // console.log('call getQueue');
                _this.getShowRoster(_this.draftData.lgm[_this.rosterTabIndex].team_id, true);
                if (_this.pickInfoBox.status != 4) {
                    // console.log('call socketConnect');
                    // we only need the draft socket set up if the draft is still active
                    _this.socketConnect();
                }
                _this.getQueue();
                _this.getPickOrder();
            });
        });
    };
    Draft2Component.prototype.openPlayerInfoBox = function (player_id, playerList, isDraft, playerData) {
        var _this = this;
        if (player_id && this.draftData.myteam_id != null && this.draftData.myteam_id > 0) {
            // const draftSelectBox = [];
            // if (this.draftData.myteam_id != null && this.draftData.myteam_id != 0 && this.pickInfoBox.status != 4 && (this.players[player_id].own == null || this.players[player_id].own == 'no')){
            //   // build draftSelectBox of available positions for this player
            //   const player = this.players[player_id];
            //   const eligiblePositions = player.pn.split(',');
            //   this.draftData.roster_position.forEach(rp => {
            //     if (rp.composed_of != null && (this.draftData.position_removed.indexOf(rp.pname) == -1)){
            //       const positions = rp.composed_of.split(',');
            //       for (let i=0;i<positions.length;i++){
            //         if (eligiblePositions.indexOf(positions[i]) > -1){
            //           draftSelectBox.push({
            //             key:rp.pname,
            //             value:rp.display_name
            //           });
            //           break;
            //         }
            //       }
            //     }
            //   });
            // }
            // console.log(draftSelectBox);
            var prevState_1 = this.sliderState;
            var abbr = (typeof (this.league.abbr) !== 'undefined') ? this.league.abbr : 'false';
            this.playerInfoRef = this.dialog.open(Playerinfobox2Component, {
                width: (this.isMobile) ? '90%' : '70%',
                height: 'auto',
                autoFocus: false,
                data: {
                    // 'player_id': player_id, 'season_id': String(this.draftData.active_season_id), 'league_id': this.league.id, 'league_team_id': this.draftData.myteam_id,
                    // 'abbr': abbr, 'draft_status': this.league.draft_status, 'leagueRecord': this.league.is_paused, 'prePlayer': 0, 'nextPlayer': 0, 'draftSelectBox': draftSelectBox
                    isDraft: isDraft,
                    league: this.league,
                    lgm_id: this.draftData.myteam_id,
                    players: playerList,
                    player_id: player_id,
                    'player_data': playerData
                }
            });
            this.playerInfoRef.afterOpen().subscribe(function (res) {
                _this.sliderState = prevState_1;
            });
        }
    };
    Draft2Component.prototype.getQueue = function () {
        var _this = this;
        // console.log('getQueue start');
        this.queue = [];
        if (this.draftData.myteam_id != null && this.draftData.myteam_id > 0) {
            this._draftService.getQueueData(this.draftData.myteam_id).subscribe(function (res) {
                // console.log('getQueueData service');
                res.arrayBuffer().then(function (buffer) {
                    if (buffer.byteLength > 1) {
                        // reconstruct int32array
                        var N = buffer.byteLength / 4;
                        var queueArr = new Int32Array(buffer, 0, N);
                        // console.log('getQueueData N: ' + N);
                        for (var index = 0; index < N; index++) {
                            _this.queue.push(queueArr[index]);
                        }
                    }
                    // console.log('call getQueuePlayers');
                    _this.getQueuePlayers();
                    // console.log('call getTablePlayers');
                    _this.getTablePlayers();
                });
            });
        }
    };
    Draft2Component.prototype.getTablePlayers = function (isFilter) {
        var _this = this;
        if (isFilter === void 0) { isFilter = null; }
        // console.log('getTablePlayers start');
        // fill table players
        this.tablePlayers = Object.keys(this.players).reduce(function (obj, key) {
            obj.push(_this.players[key]);
            return obj;
        }, []);
        // console.log('first step', this.tablePlayers);
        // sort table players
        if (this.tableSort != null) {
            this.tablePlayers.sort(function (a, b) {
                if (a[_this.tableSort] == null || b[_this.tableSort] == null)
                    return 0;
                if (_this.tableSort == 'adp') {
                    // give 0 opposite priority in ADP
                    if (a[_this.tableSort] == 0 && _this.tableSortOrder == -1)
                        return -1 * _this.tableSortOrder;
                    if (b[_this.tableSort] == 0 && _this.tableSortOrder == -1)
                        return 1 * _this.tableSortOrder;
                    if (isNaN(parseFloat(a[_this.tableSort]))) {
                        return a[_this.tableSort] > b[_this.tableSort] ? -1 * _this.tableSortOrder : 1 * _this.tableSortOrder;
                    }
                    else {
                        return parseFloat(a[_this.tableSort]) > parseFloat(b[_this.tableSort]) ? -1 * _this.tableSortOrder : 1 * _this.tableSortOrder;
                    }
                }
                if (_this.tableSort == 'fn') {
                    return a[_this.tableSort] > b[_this.tableSort] ? -1 * _this.tableSortOrder : 1 * _this.tableSortOrder;
                }
                if (_this.tableSort == 'order') {
                    return a[_this.tableSort] > b[_this.tableSort] ? -1 * _this.tableSortOrder : 1 * _this.tableSortOrder;
                }
                if (isNaN(parseFloat(a[_this.tableSort]))) {
                    return a[_this.tableSort] > b[_this.tableSort] ? 1 * _this.tableSortOrder : -1 * _this.tableSortOrder;
                }
                else {
                    return parseFloat(a[_this.tableSort]) > parseFloat(b[_this.tableSort]) ? 1 * _this.tableSortOrder : -1 * _this.tableSortOrder;
                }
            });
        }
        // team filter
        if (this.teamFilter != null && this.teamFilter != 'ALL') {
            // console.log(this.tablePlayers, this.teamFilter);
            this.tablePlayers = this.tablePlayers.filter(function (p) { return p.tn.toUpperCase() == _this.teamFilter; });
        }
        // console.log('second step', this.tablePlayers);
        if (this.search == '') {
            // remove picked players when not searching
            this.tablePlayers = this.tablePlayers.filter(function (tp) {
                return tp.own == null || tp.own != 'yes';
            });
            // console.log('picked players', this.tablePlayers);
            // if not searching, we should filter out full positions/unselected positions
            var validPos_1 = [];
            var posDict_1 = this.draftData.roster_position.reduce(function (acc, rp) {
                if (rp.id != null || rp.pname == 'Hitters')
                    acc[rp.pname] = rp.composed_of.split(',');
                return acc;
            }, {});
            // console.log(posDict, this.selectedFilters);
            this.selectedFilters.forEach(function (pos) {
                if (posDict_1[pos] != null) {
                    validPos_1 = validPos_1.concat(posDict_1[pos]);
                }
            });
            // console.log(validPos);
            this.tablePlayers = this.tablePlayers.filter(function (player) {
                var positions = player.pn.split(',');
                var isValid = false;
                positions.forEach(function (p) {
                    if (_this.draftData.position_removed.indexOf(p) == -1 && validPos_1.indexOf(p) > -1)
                        isValid = true;
                });
                return isValid;
            });
        }
        else {
            // return matching search players
            var regex_1 = new RegExp(this.search, 'gi');
            this.tablePlayers = this.tablePlayers.filter(function (player) {
                if (player.fn == null || player.ln == null)
                    return false;
                return (player.fn.match(regex_1) != null || player.ln.match(regex_1) != null || String(player.fn + ' ' + player.ln).match(regex_1) != null);
            });
            // console.log('search', this.tablePlayers);
        }
        // empty players table if draft completed or invalid lgm
        if (this.pickInfoBox.status == 4 || this.draftData.myteam_id == null || this.draftData.myteam_id == 0)
            this.tablePlayers = [];
        //chunk LAST
        // show 50 players at a time
        // console.log('chunking');
        this.tablePlayers = this.tablePlayers.filter(function (p, i) { return i >= _this.topIndex && i < _this.topIndex + 100; });
        if (this.search == '' && isFilter == null && !this.tablePlayers.length && this.pickInfoBox.status == 3) {
            this.setFilters({ pname: 'All' });
        }
        this.tablePlayers.forEach(function (p) {
            if (p.it == null)
                p.it = '';
        });
        // console.log(this.tablePlayers);
    };
    Draft2Component.prototype.setHeaderLinks = function (ent) {
        var team_slug = (ent.myteam_id != null && ent.myteam_id > 0) ? ent.lgm.filter(function (lgm) { return lgm.team_id == ent.myteam_id; })[0].team_slug : null;
        this.leagueURL = this.league.tournament_id > 0 ?
            environment.SITE_URL + "/tournament/" + this.league.lg_abbr + "/" + this.league.tournament_code :
            environment.SITE_URL + "/league/profile/" + this.league.lg_abbr + "/" + this.league.league_code;
        this.myTeamURL = (team_slug != null) ? (this.league.tournament_id > 0 ?
            environment.SITE_URL + "/tournament/my-team/" + this.league.tournament_code + "/" + this.user.id :
            environment.SITE_URL + "/manage-league/my-team/" + this.league.league_code + "/" + team_slug) :
            ('');
        this.matchupURL = this.league.tournament_id > 0 ?
            '' :
            environment.SITE_URL + "/league/matchup/" + this.league.lg_abbr + "/" + this.league.league_code;
        this.playersURL = this.league.tournament_id > 0 ?
            environment.SITE_URL + "/tournament/players/" + this.league.tournament_code :
            environment.SITE_URL + "/manage-league/players/" + this.league.league_code;
        this.draftURL = '/draft/' + this.league_id;
        this.settingsURL = this.league.tournament_id > 0 ?
            environment.SITE_URL + "/tournament/settings/" + this.league.lg_abbr + "/" + this.league.tournament_code :
            environment.SITE_URL + "/league/settings/" + this.league.lg_abbr + "/" + this.league.league_code;
    };
    Draft2Component.prototype.isVisible = function (slide, container) {
        var index = slide.total_pick - 1;
        var slideW = 81;
        var w = container.clientWidth;
        var leftIndex = Math.floor(container.scrollLeft / slideW);
        var rightIndex = Math.ceil((container.scrollLeft + w) / slideW);
        return index >= leftIndex && index < rightIndex;
    };
    Draft2Component.prototype.pRowVisible = function (index, container, type) {
        var rowH = type == 'player' ? 51 : 41;
        var topIndex = Math.floor(container.scrollTop / rowH);
        var bottomIndex = Math.ceil((container.scrollTop + container.clientHeight) / rowH);
        return index >= topIndex && index < bottomIndex;
    };
    Draft2Component.prototype.activeDraftCount = function (isActiveDraft) {
        if (isActiveDraft) {
            this.isActiveDraft = true;
        }
        else {
            this.isActiveDraft = false;
        }
    };
    Draft2Component.prototype.updateSliderScroll = function (event) {
        this.sliderScroll = event.target.scrollLeft;
    };
    Draft2Component.prototype.updatePScroll = function (event) {
        var _this = this;
        this.pScroll = event.target.scrollTop;
        // update this.topIndex here based on scrollTop and scrollHeight
        // if inside the bounds of a topIndex update, need to call getTablePlayers()
        if (!this.scrollUpdating) {
            if (this.pScroll < 5 && this.topIndex > 0) {
                this.scrollUpdating = true;
                this.topIndex -= 50;
                this.getTablePlayers();
                event.target.scrollTop = 50 * 41;
                setTimeout(function () {
                    if (event.target.scrollTop == 0 || event.target.scrollTop >= event.target.scrollHeight - event.target.clientHeight - 5)
                        event.target.scrollTop = 50 * 41;
                }, 1);
                setTimeout(function () {
                    _this.scrollUpdating = false;
                }, 500);
            }
            else if (this.pScroll >= event.target.scrollHeight - event.target.clientHeight - 5) {
                if (this.tablePlayers.length == 100) {
                    this.scrollUpdating = true;
                    this.topIndex += 50;
                    this.getTablePlayers();
                    setTimeout(function () {
                        if (event.target.scrollTop == 0 || event.target.scrollTop >= event.target.scrollHeight - event.target.clientHeight - 5)
                            event.target.scrollTop = 50 * 41 - event.target.clientHeight;
                    }, 1);
                    setTimeout(function () {
                        _this.scrollUpdating = false;
                    }, 500);
                }
            }
        }
    };
    Draft2Component.prototype.updateQScroll = function (event) {
        this.qScroll = event.target.scrollTop;
    };
    Draft2Component.prototype.startTimer = function () {
        var _this = this;
        if (this.pickInfoBox != null) {
            clearInterval(this.timeleftTimer);
            this.timeleftTimer = setInterval(function () {
                if (_this.pickInfoBox != null) {
                    _this.timeleft = Math.round(_this.pickInfoBox.timestamp + _this.delta - Date.now() / 1000);
                    if (_this.timeleft > 0 && _this.pickInfoBox.auto_pause != 1) {
                        _this.timeleft--;
                    }
                    else {
                        clearInterval(_this.timeleftTimer);
                    }
                }
            }, 1000);
        }
    };
    // /////////////////////////////////////////////////
    // /////////////////////////////////////////////////
    // Helper Functions
    //
    //
    Draft2Component.prototype.formatPickClock = function (sec) {
        if (sec >= 60 * 60 * 24) {
            // days
            return Math.floor(sec / (60 * 60 * 24)) + " day";
        }
        else if (sec >= 60 * 60) {
            // hours
            return Math.floor(sec / (60 * 60)) + " hr";
        }
        else if (sec >= 60) {
            // minutes
            return Math.floor(sec / 60) + " min";
        }
        else {
            // seconds
            return sec + " sec";
        }
    };
    Draft2Component.prototype.getScrollbarWidth = function () {
        // Creating invisible container
        var outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll'; // forcing scrollbar to appear
        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
        document.body.appendChild(outer);
        // Creating inner element and placing it in the container
        var inner = document.createElement('div');
        outer.appendChild(inner);
        // Calculating difference between container's full width and the child width
        var scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
        // Removing temporary elements from the DOM
        outer.parentNode.removeChild(outer);
        return scrollbarWidth;
    };
    Draft2Component.prototype.getRGBAColor = function (color) {
        return 'rgba(' + parseInt('0x' + color.substr(1, 2), 16) + ',' + parseInt('0x' + color.substr(3, 2), 16) + ',' + parseInt('0x' + color.substr(5, 2), 16) + ',' + color.substr(8) + ')';
    };
    Draft2Component.prototype.setFilters = function (rp) {
        // console.log(rp);
        this.topIndex = 0;
        this.playersTable.nativeElement.scrollTop = 0;
        if (rp.pname == 'All') {
            this.selectedFilters = this.draftData.roster_position.reduce(function (obj, elm) {
                obj.push(elm.pname);
                return obj;
            }, []);
        }
        else {
            // if (this.selectedFilters.indexOf(rp.pname) > -1) {
            //   if ((this.selectedFilters.length <= 2 && this.selectedFilters.indexOf('All') > -1) || (this.selectedFilters.length == 1 && this.selectedFilters.indexOf('All') == -1)) {
            //     // turn on all if turning off all
            //     this.selectedFilters = this.draftData.roster_position.reduce((obj, elm) => {
            //       obj.push(elm.pname);
            //       return obj;
            //     }, []);
            //   } else if (this.selectedFilters.length == this.draftData.roster_position.length) {
            //     // if all activated, only activate selected position
            //     this.selectedFilters = [rp.pname];
            //   } else {
            //     // regular removal
            //     this.selectedFilters.splice(this.selectedFilters.indexOf(rp.pname), 1);
            //   }
            // } else {
            //   // regular addition
            //   this.selectedFilters.push(rp.pname);
            // }
            // Single position toggle, uncomment above section for multiple position toggle
            if (this.selectedFilters.length == 1 && this.selectedFilters[0] == rp.pname) {
                this.setFilters({ pname: 'All' });
            }
            else {
                this.selectedFilters = [rp.pname];
            }
            // end single position toggle, comment above out if you switch to multiple position
        }
        this.getTablePlayers(true);
    };
    Draft2Component.prototype.getStyle = function (pname) {
        if (this.selectedFilters.indexOf(pname) == 0) {
            return this.filterStyles[pname];
        }
        else {
            return this.filterStyles[pname + '-off'];
        }
    };
    Draft2Component.prototype.getPlayersHeight = function (elm) {
        if (!this.isMobile) {
            return (window.innerHeight - elm.getBoundingClientRect().top - 10);
        }
        else {
            return (window.innerHeight - elm.getBoundingClientRect().top - 60);
        }
    };
    Draft2Component.prototype.getQueuePlayers = function (debug) {
        var _this = this;
        if (debug === void 0) { debug = false; }
        this.queuePlayers = [];
        this.queue.forEach(function (id) {
            if (debug)
                console.log(_this.players[id]);
            var isOwn = (_this.players[id] != null && _this.players[id].own != null && _this.players[id].own == 'yes');
            if (!isOwn)
                _this.queuePlayers.push(_this.players[id]);
        });
        this.queuePlayers = this.queuePlayers.filter(function (player) {
            var positions = player.pn.split(',');
            var isValid = false;
            positions.forEach(function (p) {
                if (_this.draftData.position_removed.indexOf(p) == -1)
                    isValid = true;
            });
            return isValid;
        });
        this.queuePlayers.forEach(function (p) {
            if (p.it == null)
                p.it = '';
        });
        // draft completed or invalid lgm, empty queue table
        if (this.pickInfoBox.status == 4 || this.draftData.myteam_id == null || this.draftData.myteam_id == 0)
            this.queuePlayers = [];
        if (debug)
            console.log(this.queue, this.queuePlayers);
    };
    Draft2Component.prototype.addToQueue = function (player) {
        if (this.queue.indexOf(player.id) == -1) {
            this.queue.push(player.id);
            this._draftService.addToQueue(this.draftData.myteam_id, player.id).subscribe(function (res) {
                // console.log(res);
            });
        }
        else {
            this.queue.splice(this.queue.indexOf(player.id), 1);
            this._draftService.removeFromQueue(this.draftData.myteam_id, player.id).subscribe(function (res) {
                // console.log(res);
            });
        }
        this.getQueuePlayers();
    };
    Draft2Component.prototype.getSchedule = function (player) {
        var result = '';
        if (player.tml == 'home') {
            // result += 'vs.';
        }
        else {
            result += '@';
        }
        result += player.opn.toUpperCase();
        return result;
    };
    Draft2Component.prototype.getNameWidth = function (name) {
        var w = window.innerWidth;
        if (w > 400) {
            return '16px';
        }
        else if (name.length > 14) {
            return '12px';
        }
        else if (name.length > 10) {
            return '14px';
        }
        else {
            return '16px';
        }
    };
    Draft2Component.prototype.getPickBar = function (slide) {
        if (this.currentPick > slide.total_pick) {
            return slide.player;
        }
        else if (this.pickInfoBox.is_active == 1) {
            return 'Your Pick!';
        }
        else {
            return 'Picking';
        }
    };
    Draft2Component.prototype.getLeagueStatus = function () {
        if (this.pickInfoBox == null)
            return '';
        switch (this.pickInfoBox.status) {
            case 1:
                return 'Registering';
                break;
            case 2:
                return 'Pre-Draft';
                break;
            case 3:
                return 'Drafting';
                break;
            case 4:
                return 'Draft Complete';
                break;
            case 5:
                return 'Paused';
                break;
            default:
                return 'Draft Complete';
                break;
        }
        ;
    };
    Draft2Component.prototype.myPlayersCount = function () {
        var _this = this;
        return this.slider.reduce(function (acc, item) {
            if (item.lgm_id == _this.draftData.myteam_id && item.player != null)
                acc++;
            return acc;
        }, 0);
    };
    Draft2Component.prototype.disableAutoPick = function () {
        // if (this.league.duration_id != 8 && this.pickInfoBox.status != 5) this.isMessage = 'close';
        this.isAutoPick = false;
        this._resultboardService.disableAutoPick(this.league.id, this.draftData.myteam_id);
    };
    Draft2Component.prototype.enableAutoPick = function () {
        this.isAutoPick = true;
        this.isMessage = 'open';
        this._resultboardService.enableManualAutoPick(this.league_id, this.draftData.myteam_id);
    };
    Draft2Component.prototype.searchDelay = function () {
        var _this = this;
        clearInterval(this.searchTimer);
        this.searchTimer = setTimeout(function () {
            _this.getTablePlayers();
        }, 800);
    };
    Draft2Component.prototype.clearSearch = function () {
        this.search = '';
        this.getTablePlayers();
    };
    Draft2Component.prototype.clearFilter = function () {
        this.teamFilter = null;
        this.getTablePlayers();
    };
    Draft2Component.prototype.tabChange = function (event) {
        if (!this.isMobile) {
            if (event.index == 2) {
                // chat tab
                this.unreadMessages = 0;
            }
            else if (event.index == 0) {
                // roster tab
                if (this.draftData)
                    this.getShowRoster(this.draftData.lgm[this.rosterTabIndex].team_id, true);
            }
            else if (event.index == 3) {
                // info tab
                if (this.infoTab == null || this.scoringTab == null) {
                    this.getInfoTab();
                }
            }
            // else if (event.index == 3){
            //   // table view
            //   this.getPickOrder();
            // }
        }
        else {
            if (event.index == 2) {
                // chat tab
                this.unreadMessages = 0;
            }
            else if (event.index == 3) {
                // roster tab
                this.getShowRoster(this.draftData.lgm[this.rosterTabIndex].team_id, true);
            }
            else if (event.index == 4) {
                // info tab
                if (this.infoTab == null || this.scoringTab == null) {
                    this.getInfoTab();
                }
            }
        }
    };
    Draft2Component.prototype.getModalState = function (modal) {
        if (this.isMobile) {
            if (modal == 0) {
                return (this.showModal) ? 'openMobile' : 'closeMobile';
            }
            else {
                return (this.showRankings) ? 'openMobile' : 'closeMobile';
            }
        }
        else {
            if (modal == 0) {
                return (this.showModal) ? 'openDesktop' : 'closeDesktop';
            }
            else {
                return (this.showRankings) ? 'openDesktop' : 'closeDesktop';
            }
        }
    };
    Draft2Component.prototype.getShowRoster = function (lgm_id, hideModal, changeRoster) {
        var _this = this;
        if (hideModal === void 0) { hideModal = false; }
        if (changeRoster === void 0) { changeRoster = true; }
        if (this.pickInfoBox.status == 4 && this.showModal == true)
            return false;
        // if(changeRoster==false) return;
        this.current_lgm_id = lgm_id;
        this.showRoster = {};
        var slides = this.slider.filter(function (slide) { return slide.lgm_id == lgm_id; });
        // console.log(slides);
        this.showRosterOwner = this.draftData.lgm.filter(function (lm) { return lm.team_id == lgm_id; })[0];
        // this.showRosterOwner = slides[0].team_name;
        slides.forEach(function (slide) {
            var pos = _this.draftData.roster_position.filter(function (rp) {
                return (rp.id != null && slide.p_pos != null && slide.player != null && rp.id == slide.p_pos);
            });
            if (pos.length) {
                slide.pname = pos[0].pname;
                slide.profile_image_uri = slide.player_picture.replace(environment.assetURL + "/", '');
                slide.order_id = pos[0].order_id;
                pos = pos[0].display_name;
                if (_this.showRoster[pos] == null) {
                    _this.showRoster[pos] = [];
                }
                _this.showRoster[pos].push(slide);
            }
        });
        this.draftData.roster_position.forEach(function (rp, ii) {
            if (rp.pname != 'All') {
                rp.pick_remain = rp.tpick;
                rp.isprinted = false;
                Object.values(_this.showRoster).forEach(function (el2) {
                    Object.values(el2).forEach(function (v, i) {
                        if (v.pname == rp.pname) {
                            rp.isprinted = true;
                            rp.pick_remain = --rp.pick_remain;
                        }
                    });
                });
            }
        });
        if (Object.keys(this.showRoster).length) {
            Object.keys(this.showRoster).forEach(function (key) {
                _this.showRoster[key].sort(function (a, b) {
                    return (a.total_pick > b.total_pick) ? 1 : -1;
                });
            });
            if (hideModal == false && this.pickInfoBox.status == 4 && (this.pickInfoBox.message == 'Draft Completed')) {
                this.showCamIcon = false;
                this.showLoadingBorder = true;
                this.getURL();
                this.getDraftSummry(this.draftData.myteam_id);
            }
            if (!hideModal)
                this.showModal = true;
        }
        else {
            this.showModal = false;
        }
        this.getDraftSummry();
    };
    Draft2Component.prototype.getDraftSummry = function (lgm_id) {
        var _this = this;
        if (lgm_id === void 0) { lgm_id = null; }
        var openModel = lgm_id ? true : false;
        this.showRosterNew = {};
        var currentUserFilled = {};
        if (lgm_id)
            this.currentinfoid = lgm_id;
        else if (this.currentinfoid)
            lgm_id = this.currentinfoid;
        else
            return false;
        var slides = this.slider.filter(function (slide) { return slide.lgm_id == lgm_id; });
        this.showRosterOwner = this.draftData.lgm.filter(function (lm) { return lm.team_id == lgm_id; })[0];
        slides.forEach(function (slide) {
            var pos = _this.draftData.roster_position.filter(function (rp) {
                return (rp.id != null && slide.p_pos != null && slide.player != null && rp.id == slide.p_pos);
            });
            if (pos.length) {
                slide.pname = pos[0].pname;
                slide.profile_image_uri = slide.player_picture.replace(environment.assetURL + "/", '');
                slide.order_id = pos[0].order_id;
                pos = pos[0].display_name;
                if (_this.showRosterNew[pos] == null) {
                    _this.showRosterNew[pos] = [];
                }
                _this.showRosterNew[pos].push(slide);
            }
            if (currentUserFilled[slide.p_pos] != null) {
                currentUserFilled[slide.p_pos]++;
            }
            else {
                currentUserFilled[slide.p_pos] = 1;
            }
        });
        this.draftData.roster_position.forEach(function (rp, ii) {
            if (rp.pname != 'All') {
                rp.pick_remain = rp.tpick;
                rp.isprinted = false;
                Object.values(_this.showRosterNew).forEach(function (el2) {
                    Object.values(el2).forEach(function (v, i) {
                        if (v.pname == rp.pname) {
                            rp.isprinted = true;
                            rp.pick_remain = --rp.pick_remain;
                        }
                    });
                });
            }
        });
        if (Object.keys(this.showRosterNew).length) {
            Object.keys(this.showRosterNew).forEach(function (key) {
                _this.showRosterNew[key].sort(function (a, b) {
                    return (a.total_pick > b.total_pick) ? 1 : -1;
                });
            });
        }
        this.hoverRosterPopup = this.draftData.roster_position.reduce(function (acc2, e) {
            if (e.id != null) {
                acc2.push({
                    position: e.pname,
                    bgcolor: _this.getRGBAColor(e.color_code),
                    filled: (currentUserFilled[e.id] != null) ? currentUserFilled[e.id] : 0,
                    total: e.tpick
                });
            }
            return acc2;
        }, []);
        if (openModel) {
            if (Object.keys(this.showRosterNew).length) {
                this.showModal = true;
                if (this.pickInfoBox.status == 4) {
                    this.showCamIcon = false;
                    this.showLoadingBorder = true;
                    this.getURL();
                }
            }
        }
    };
    Draft2Component.prototype.rtIndexChange = function (increment) {
        if (increment == 'custom') {
        }
        else if (increment) {
            if (this.rosterTabIndex < this.draftData.lgm.length - 1) {
                this.rosterTabIndex++;
            }
            else {
                this.rosterTabIndex = 0;
            }
        }
        else {
            if (this.rosterTabIndex > 0) {
                this.rosterTabIndex--;
            }
            else {
                this.rosterTabIndex = this.draftData.lgm.length - 1;
            }
        }
        this.getShowRoster(this.draftData.lgm[this.rosterTabIndex].team_id, true);
    };
    Draft2Component.prototype.getInfoTab = function () {
        var _this = this;
        var sub = this._resultboardService.getInfoTabs(this.league.tournament_id, this.league.id, this.user.id, 'info').subscribe(function (res) {
            if (res.status == 'success')
                _this.infoTab = res.entities;
            var sub2 = _this._resultboardService.getInfoTabs(_this.league.tournament_id, _this.league.id, _this.user.id, 'scoring').subscribe(function (res2) {
                // res == info tab, res2 == scoring tab
                if (res2.status == 'success')
                    _this.scoringTab = res2.entities;
                // console.log(this.infoTab,this.scoringTab);
                sub2.unsubscribe();
            });
            sub.unsubscribe();
        });
    };
    Draft2Component.prototype.updateCPick = function () {
        var _this = this;
        var myPicks = this.slider.filter(function (s) { return (s.lgm_id == _this.draftData.myteam_id && s.p_pos != null); });
        var cPicks = {};
        myPicks.forEach(function (p) {
            if (cPicks[p.p_pos] == null) {
                cPicks[p.p_pos] = 1;
            }
            else {
                cPicks[p.p_pos]++;
            }
        });
        this.draftData.roster_position.forEach(function (rp) {
            if (cPicks[rp.id] != null)
                rp.cpick = cPicks[rp.id];
        });
    };
    Draft2Component.prototype.getPickOrder = function () {
        var temp = [];
        // this.pickOrder = [];
        this.slider.forEach(function (s) {
            if (temp[s.round - 1] == null) {
                temp[s.round - 1] = [s];
            }
            else {
                temp[s.round - 1].push(s);
            }
        });
        // snake display
        temp.forEach(function (round, i) {
            if (i % 2)
                round.reverse();
        });
        this.pickOrder = temp;
        // console.log('getPickOrder', this.pickOrder);
    };
    Draft2Component.prototype.getPosition = function (id) {
        var res = this.draftData.roster_position.filter(function (rp) { return rp.id == id; });
        if (res.length) {
            return res[0].pname;
        }
        else {
            return '';
        }
    };
    Draft2Component.prototype.getAutoPickStatus = function () {
        return !this.isAutoPick;
    };
    Draft2Component.prototype.autoCheckbox = function (checkbox) {
        this.isAutoPick = !checkbox.checked;
        if (!checkbox.disabled) {
            if (!this.isAutoPick) {
                this.enableAutoPick();
            }
            else {
                this.disableAutoPick();
            }
        }
    };
    Draft2Component.prototype.removeAllPositions = function () {
        var _this = this;
        this.draftData.roster_position.forEach(function (rp) {
            if (rp.id != null && _this.roster_removed.indexOf(rp.pname) == -1) {
                _this.roster_removed.push(rp.pname);
            }
        });
    };
    Draft2Component.prototype.getImportList = function () {
        var _this = this;
        if (this.pickInfoBox.status != 4) {
            this.rankingSets = [];
            this.showLoading = true;
            this._resultboardService.getRankingSets(this.league.game_id, this.league.egs, this.league.lgs, this.user.id, this.league.id).subscribe(function (res) {
                _this.showLoading = false;
                if (res.status == 'success' && res.entities.length) {
                    _this.rankingSets = res.entities;
                    _this.showRankings = true;
                }
                else {
                    // display no ranking sets message
                    _this.openSnackBar('No ranking sets to import', 'OK');
                }
            });
        }
    };
    Draft2Component.prototype.openSnackBar = function (message, action) {
        this.snackBar.open(message, action, {
            duration: 2000,
        });
    };
    Draft2Component.prototype.importSet = function (id) {
        var _this = this;
        this.showRankings = false;
        this.showLoading = true;
        this._resultboardService.importRankings(this.league.id, this.draftData.myteam_id, id, this.user.id).subscribe(function (res) {
            // console.log(res);
            _this.getPlayerPool(true);
            _this.common_rank_id = id;
            _this.showLoading = false;
        });
    };
    Draft2Component.prototype.setRosterRemoved = function () {
        var _this = this;
        this.roster_removed = [];
        this.draftData.roster_position.forEach(function (rp) {
            if (rp.id != null && rp.cpick >= rp.tpick) {
                if (_this.league.duration_id == 8) {
                    // best ball logic
                    var details = _this.draftData.roster_position.reduce(function (acc, r) {
                        if (r.id != null) {
                            acc.drafted += r.cpick;
                            if (r.tpick > r.cpick) {
                                acc.needed += r.tpick - r.cpick;
                            }
                        }
                        return acc;
                    }, {
                        needed: 0,
                        drafted: 0
                    });
                    // console.log('details',details,'total_players',this.league.total_players);
                    if (details.needed >= _this.league.total_players - details.drafted) {
                        _this.roster_removed.push(rp.pname);
                    }
                }
                else {
                    _this.roster_removed.push(rp.pname);
                }
            }
            if (rp.pname == 'All') {
                rp.cpick = _this.draftData.roster_position.reduce(function (acc, r) {
                    if (r.pname != 'All')
                        acc += r.cpick;
                    return acc;
                }, 0);
            }
        });
    };
    Draft2Component.prototype.isEmptyObject = function (obj) {
        return (Object.keys(obj).length > 0) ? false : true;
    };
    Draft2Component.prototype.getTableHeaderWidth = function (tContainer, tableContainer) {
        if (tContainer.scrollWidth > tableContainer.clientWidth) {
            return tContainer.scrollWidth + 'px';
        }
        else {
            return '100%';
        }
    };
    Draft2Component.prototype.unsubSockets = function () {
        if (this.s_disconnect)
            this.s_disconnect.unsubscribe();
        if (this.s_pong)
            this.s_pong.unsubscribe();
        if (this.s_refreshPage)
            this.s_refreshPage.unsubscribe();
        if (this.s_isMobileScreen)
            this.s_isMobileScreen.unsubscribe();
        if (this.s_initListener)
            this.s_initListener.unsubscribe();
        if (this.s_navigation)
            this.s_navigation.unsubscribe();
        if (this.s_activeDraft)
            this.s_activeDraft.unsubscribe();
        if (this.s_listActiveDraft)
            this.s_listActiveDraft.unsubscribe();
        if (this.s_pickChanges)
            this.s_pickChanges.unsubscribe();
        if (this.s_pickTime)
            this.s_pickTime.unsubscribe();
        if (this.s_pickedPlayer)
            this.s_pickedPlayer.unsubscribe();
        if (this.s_draftCompleted)
            this.s_draftCompleted.unsubscribe();
        if (this.s_showDraft)
            this.s_showDraft.unsubscribe();
        if (this.s_draftReset)
            this.s_draftReset.unsubscribe();
        if (this.s_leaguePost)
            this.s_leaguePost.unsubscribe();
        if (this.s_pausedMessage)
            this.s_pausedMessage.unsubscribe();
        if (this.s_resumeMessage)
            this.s_resumeMessage.unsubscribe();
        if (this.s_readybox)
            this.s_readybox.unsubscribe();
        if (this.s_reversePick)
            this.s_reversePick.unsubscribe();
        this.leaveRoom();
    };
    Draft2Component.prototype.checkMissedPicks = function (pnum) {
        var _this = this;
        var results = this.slider.filter(function (s) { return s.total_pick < pnum && s.player == null; });
        // if (results.length) console.log('MISSED PICK!!!', pnum, results);
        if (results.length) {
            this.openSnackBar('Data Desynchronized, Refreshing...', 'OK');
            setTimeout(function () {
                if (_this.reloadConfirmDialogRef)
                    _this.reloadConfirmDialogRef.close();
                _this.reloadConfirmDialogRef = _this.dialog.open(ConfirmboxComponent, {
                    width: '500px',
                    data: { 'title': "Refresh Page Alert", 'body': 'Data Desynchronized. Please refresh the page.' }
                });
                _this.reloadConfirmDialogRef.afterClosed().subscribe(function (res) {
                    document.location.reload();
                });
            }, 2000);
        }
    };
    Draft2Component.prototype.getBye = function (id) {
        return (this.players != null && this.players[id] != null && this.players[id].bye != null) ? this.players[id].bye : 0;
    };
    Draft2Component.prototype.getAdp = function (id) {
        return (this.players != null && this.players[id] != null && this.players[id].adp != null) ? this.players[id].adp : 0;
    };
    Draft2Component.prototype.prettyPrint = function (number) {
        var rem = number % 100;
        if (rem > 10 && rem < 21) {
            // awkward teens :p
            return number + 'th';
        }
        else {
            var rem2 = number % 10;
            if (rem2 == 1)
                return number + 'st';
            if (rem2 == 2)
                return number + 'nd';
            if (rem2 == 3)
                return number + 'rd';
            return number + 'th';
        }
    };
    Draft2Component.prototype.changeView = function () {
        var _this = this;
        this.currentView = (this.currentView == 'table') ? 'slider' : 'table';
        setTimeout(function () {
            if (_this.pickInfoBox.status == 3 || _this.pickInfoBox.status == 5) {
                // slide to current pick far right, or just 0
                if (_this.currentView == 'slider') {
                    var sliderRef = _this.sliderContainer.nativeElement;
                    sliderRef.scrollLeft = ((_this.currentPick - Math.floor(sliderRef.clientWidth / 95) > 0) ? (_this.currentPick - Math.floor(sliderRef.clientWidth / 95)) * 95 - 1 : 0);
                }
                else {
                    var tRef = _this.tContainer.nativeElement;
                    if (!_this.showResetIcon) {
                        tRef.scrollTop = ((Math.floor((_this.currentPick - 1) / _this.draftData.lgm.length) - 5) * 40);
                        setTimeout(function () {
                            _this.showResetIcon = false;
                        }, 800);
                    }
                    if (tRef.scrollWidth > tRef.clientWidth) {
                        tRef.scrollLeft = (Math.floor((_this.currentPick - 1) / _this.draftData.lgm.length) % 2) ? 30 + ((_this.draftData.lgm.length - ((_this.currentPick - 1) % _this.draftData.lgm.length)) - 3) * 95 : 30 + ((((_this.currentPick - 1) % _this.draftData.lgm.length) - 2) * 95);
                    }
                }
                if (_this.currentView == 'table') {
                    setTimeout(function () {
                        _this.resetTableRowsView();
                    });
                }
            }
        }, 500);
    };
    Draft2Component.prototype.availRoster = function (pos) {
        var _this = this;
        // roster_removed.indexOf(rp.pname) > -1
        var basePos = [];
        this.draftData.roster_position.forEach(function (rp) {
            if (_this.roster_removed.indexOf(rp.pname) == -1) {
                basePos = basePos.concat(rp.composed_of.split(','));
            }
        });
        basePos = basePos.reduce(function (acc, c) {
            if (acc.indexOf(c) == -1)
                acc.push(c);
            return acc;
        }, []);
        return (this.roster_removed.indexOf(pos) == -1 || basePos.indexOf(pos) > -1);
    };
    Draft2Component.prototype.updateHoverStyle = function (element, lgm_id, event) {
        event.stopPropagation();
        event.preventDefault();
        this.getHoverRoster(lgm_id);
        var pos = element.getBoundingClientRect();
        this.hoverStyle.top = Math.round(pos.top + element.clientHeight) + 'px';
        this.hoverStyle.left = Math.round(pos.left) + 'px';
        this.hoverStyle.width = element.clientWidth + 'px';
        this.hoverStyle.display = 'block';
    };
    Draft2Component.prototype.getHoverRoster = function (lgm_id) {
        var _this = this;
        if (!lgm_id)
            return;
        var userFilled = {};
        var userPicks = this.slider.filter(function (s) { return s.lgm_id == lgm_id; });
        userPicks.forEach(function (p) {
            if (userFilled[p.p_pos] != null) {
                userFilled[p.p_pos]++;
            }
            else {
                userFilled[p.p_pos] = 1;
            }
        });
        this.hoverRoster = this.draftData.roster_position.reduce(function (acc, e) {
            if (e.id != null) {
                acc.push({
                    position: e.pname,
                    bgcolor: _this.getRGBAColor(e.color_code),
                    filled: (userFilled[e.id] != null) ? userFilled[e.id] : 0,
                    total: e.tpick
                });
            }
            return acc;
        }, []);
        this.getRosterData[lgm_id] = this.hoverRoster;
    };
    Draft2Component.prototype.queueDrop = function (oldIndex, newIndex) {
        var _this = this;
        var player = this.queuePlayers[newIndex];
        if (player != null && (this.players[player.id].own == null || this.players[player.id].own !== 'yes')) {
            var insertBefore = null;
            var isLast = false;
            var isFirst = false;
            if (newIndex == 0) {
                isFirst = true;
            }
            else if (newIndex == this.queuePlayers.length - 1) {
                isLast = true;
            }
            else {
                var nextPlayer = this.queuePlayers[newIndex + 1];
                insertBefore = nextPlayer.id;
            }
            // splice local queue
            this.queue.splice(this.queue.indexOf(player.id), 1);
            if (isFirst) {
                this.queue.unshift(player.id);
            }
            else if (isLast) {
                this.queue.push(player.id);
            }
            else {
                this.queue.splice(this.queue.indexOf(insertBefore), 0, player.id);
            }
            // use isFirst, isLast, and insertBefore to send to server and update queue
            this._draftService.adjustQueue(this.draftData.myteam_id, isFirst, isLast, insertBefore, player.id).subscribe(function (res) {
                // sort queue again, in case picks have been made in the interim
                _this.getQueuePlayers();
            });
        }
        else {
            // player is already picked, do something here
            if (player != null && player.id != null) {
                this.queue.splice(this.queue.indexOf(player.id), 1);
                this.queuePlayers.splice(newIndex, 1);
            }
            this.getQueuePlayers();
        }
    };
    Draft2Component.prototype.changeTableFilter = function (value) {
        if (value == this.tableSort) {
            this.tableSortOrder = (this.tableSortOrder == 1) ? -1 : 1;
        }
        else {
            this.tableSort = value;
        }
        if (value == 'order')
            this.tableSortOrder = -1;
        this.getTablePlayers();
    };
    Draft2Component.prototype.changeTableRows = function (inc) {
        if (inc === void 0) { inc = true; }
        this.showResetIcon = true;
        if (inc) {
            if (this.tableNumRows < this.league_rounds)
                this.tableNumRows++;
        }
        else {
            if (this.tableNumRows > 1)
                this.tableNumRows--;
        }
        this.tableCHeight = (this.tableCHeight == 'none') ? 'none' : this.tableHeaderHeight + (this.tableNumRows * 38) + "px";
    };
    Draft2Component.prototype.resetTableRowsView = function () {
        var _this = this;
        if (this.currentView == 'table') {
            var cr = Math.ceil(this.currentPick / this.draftData.lgm.length);
            var tRef = this.tContainer.nativeElement;
            if (this.tableNumRows + (cr - 6) > this.league_rounds) {
                setTimeout(function () {
                    _this.resetTableRowsView();
                }, 1000);
            }
            setTimeout(function () {
                _this.showResetIcon = false;
            }, 200);
            this.tableNumRows = 6;
            this.tableCHeight = (this.tableCHeight == 'none') ? 'none' : this.tableHeaderHeight + (this.tableNumRows * 38) + "px";
            tRef.scrollTop = ((Math.floor((this.currentPick - 1) / this.draftData.lgm.length) - 5) * 38);
        }
    };
    Draft2Component.prototype.resultrBoardScrollEvent = function (event) {
        this.showResetIcon = true;
    };
    Draft2Component.prototype.getPickMessage = function () {
        var _this = this;
        if (this.slider != null && this.slider[this.currentPick - 1] != null && this.draftData.myteam_id == this.slider[this.currentPick - 1].lgm_id) {
            // my pick!
            return 'Your Pick!';
        }
        else {
            // not my pick
            var next = this.slider.findIndex(function (e, i) { return i > _this.currentPick - 1 && e.lgm_id == _this.draftData.myteam_id; });
            if (next == -1) {
                return 'Draft Completed';
            }
            else {
                return next - (this.currentPick - 1) + " " + (next - (this.currentPick - 1) > 1 ? 'Picks' : 'Pick') + " Away";
            }
        }
    };
    Draft2Component.prototype.getPickClock = function (timeleft) {
        if (timeleft > 60 * 60 * 24) {
            // days
            var days = Math.floor(timeleft / (60 * 60 * 24));
            return days + " " + (days > 1 ? 'days' : 'day');
        }
        else if (timeleft > 60 * 60) {
            // hours
            var hours = Math.floor(timeleft / (60 * 60));
            var minutes = Math.floor(timeleft / 60) % 60;
            var seconds = timeleft % 60;
            return this.tp(hours) + ":" + this.tp(minutes) + ":" + this.tp(seconds);
        }
        else {
            // minutes
            var minutes = Math.floor(timeleft / 60);
            var seconds = timeleft % 60;
            return this.tp(minutes) + ":" + this.tp(seconds);
        }
    };
    Draft2Component.prototype.tp = function (val) {
        return (val.toString().length == 1) ? "0" + val : "" + val;
    };
    Draft2Component.prototype.getPositionColor = function (p) {
        // Check hashmap first
        if (this.positionColors[p] != null) {
            return this.positionColors[p];
        }
        // This only matches first instance of, no additional logic (base versus composed, etc.)
        var found = this.draftData.roster_position.find(function (rp) { return rp.composed_of.split(',').indexOf(p) > -1 && rp.pname != 'Hitters'; });
        if (!found) {
            var found2 = this.draftData.roster_position.find(function (rp) { return rp.pname == p; });
            if (!found2)
                return !this.darkMode ? '#000' : '#FFF';
            this.positionColors[p] = this.getRGBAColor(found2.color_code);
        }
        else {
            this.positionColors[p] = this.getRGBAColor(found.color_code);
        }
        return this.positionColors[p];
    };
    Draft2Component.prototype.getInjuryAbbr = function (desc) {
        switch (desc) {
            case 'Out':
                return 'O';
            case 'Day-To-Day':
                return 'Q';
            case 'IR':
                return 'O';
            case 'IR-NR':
                return 'O';
            case 'IR-LT':
                return 'O';
            case 'QUESTIONABLE':
                return 'Q';
            case 'DOUBTFUL':
                return 'O';
            case 'OUT':
                return 'O';
            case 'INACTIVE':
                return 'O';
            case 'PUP-R':
                return 'O';
            case 'PUP-P':
                return 'O';
            case 'IR-R':
                return 'O';
            case 'IR':
                return 'O';
            case 'RESERVE-DNR':
                return 'O';
            case 'NFI-R':
                return 'O';
            case 'NFI-A':
                return 'O';
            case 'RESERVE-CEL':
                return 'O';
            case 'RESERVE-SUS':
                return 'O';
            case 'RESERVE-RET':
                return 'O';
            case 'RESERVE-EX':
                return 'O';
            case 'RESERVE-COVID-19':
                return 'O';
            case 'GTD':
                return 'D';
            case 'OUT':
                return 'O';
            case 'OFS':
                return 'O';
            case '60-Day IL':
                return 'O';
            case '15-Day IL':
                return 'O';
            case '10-Day IL':
                return 'O';
            case 'Out':
                return 'O';
            case '7-Day IL':
                return 'O';
            case 'Suspension':
                return 'O';
            case 'Paternity':
                return 'O';
            case 'Bereavement':
                return 'O';
            case 'COVID-19':
                return 'O';
            default:
                return desc.charAt(0);
        }
    };
    Draft2Component.prototype.getPositions = function (pn) {
        return pn.split(',');
    };
    Draft2Component.prototype.toggleDarkTheme = function () {
        var _this = this;
        this.darkMode = !this.darkMode;
        setTimeout(function () {
            if (_this.darkMode)
                document.body.classList.add('dark-theme');
            else
                document.body.classList.remove('dark-theme');
        }, 100);
        localStorage.setItem('darkMode', this.darkMode ? 'true' : 'false');
    };
    Draft2Component.prototype.downloadImage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                setTimeout(function () {
                    _this.showCanvas = true;
                    html2canvas(_this.screen.nativeElement, { scale: 3, allowTaint: true, useCORS: true, backgroundColor: _this.darkMode ? "#0E1523" : "#f5f5f5" }).then(function (canvas) {
                        _this.downloadLink.nativeElement.href = canvas.toDataURL("image/png");
                        _this.canvas.nativeElement.src = canvas.toDataURL("image/png");
                        _this.downloadLink.nativeElement.download = "draft-summary-" + _this.showRosterOwner.team_name + ".png";
                        _this.downloadLink.nativeElement.click();
                        _this.showCanvas = false;
                        setTimeout(function () {
                            _this.showCamIcon = true;
                        }, 500);
                    });
                }, 100);
                return [2 /*return*/];
            });
        });
    };
    Draft2Component.prototype.getURL = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newImg, request_left, chunks, i, chunk, k, timer;
            var _this = this;
            return __generator(this, function (_a) {
                this.showLoadingBorder = false;
                return [2 /*return*/, true];
            });
        });
    };
    Draft2Component.prototype.draftPlayer = function (player_id, playerList, isDraft, playerData) {
        this.disableDraft = true;
        var data = {
            picker_id: String(this.draftData.myteam_id),
            league_id: String(this.league.id),
            player_id: String(player_id),
            player_name: playerData.fn + ' ' + playerData.ln,
            player_team: playerData.tn,
            player_position: playerData.pn,
            pick_number: Number(this.currentPick),
            plr_team_id: String(playerData.tid),
            profile_pic: playerData.pp,
            device: 'web',
            pickedFrom: 'swipe',
            filteredPosition: this.selectedFilters[0]
        };
        var sub = this._resultboardService.draftButtonEmit(data).subscribe(function (res) {
            sub.unsubscribe();
        });
    };
    Draft2Component.prototype.breakPlayerName = function (fullName) {
        var maxLength = 15;
        if (fullName.length <= maxLength) {
            return fullName;
        }
        var nameParts = fullName.split(' ');
        if (nameParts.length < 2) {
            return fullName;
        }
        var firstName = nameParts[0];
        var lastName = nameParts.slice(1).join(' ');
        var breakFirstName = firstName.charAt(0) + '.';
        var breakName = breakFirstName + " " + lastName;
        return breakName;
    };
    return Draft2Component;
}());
export { Draft2Component };
